<template lang="pug">
//- MEMO: なぜか別のコンポーネントにしなければUnknown custom element:
//- になるので同じコンポーネントを名前を変えて複数利用している
div(@click="addSelectedAsset(asset.id)").wrap-item-asset-card-to-add.s-w-full.mb16.cursor-pointer
  div.wrap-img.relative.f.fh.w-full.mb8
    img(:src="asset.mainImg").object-fit-cover.h-full
    div.wrap-type.absolute.t8.l8.f.fh.w24.h24.rounded
      v-icon(dark size="16px") {{getIconByAssetType(asset.type)}}
    div(v-if="!canNotBeAdded").wrap-check-icon.absolute.t12.r12
      v-icon(v-if="assetIdsToAdd.includes(asset.id)"
        :color="pallete.$active_color") mdi-check-circle
      v-icon(v-else
        :color="pallete.$deactive_color") mdi-checkbox-blank-circle-outline
    div(v-else).absolute.t12.r12
      v-icon mdi-cancel
  div
    div.f.fm.flex-between.mb4
      span.line-clamp-1.mr4 {{asset.name}}
      div.f.fm.pr4
        ItemAssetFavorite(:asset="asset" :me="user")
        //- v-icon(@click.stop="onFavorite"
          :color="isFavoriteAsset ? pallete.$favorite_color : pallete.$deactive_color"
          ).mr2 {{isFavoriteAsset ? 'mdi-star' : 'mdi-star-outline'}}
        //- v-icon(@click.stop="onFavorite"
          :color="isFavoriteAsset ? pallete.$like_color : pallete.$deactive_color"
          ).mr2 {{isFavoriteAsset ? 'mdi-heart' : 'mdi-heart-outline'}}
        v-icon(@click.stop="onPreview(asset)"
          :color="pallete.$deactive_color") mdi-file-find
    div.wrap-tags.f.flex-wrap
      span(v-for="tag in asset.tags"
        @click.stop="onTag(tag)").tag.fz14.px8.py4.mr8.mb8.rounded {{'#' + tag}}

  ModalWindow(:showModal="showDetailModalWindow"
    @closeModalWindow="showDetailModalWindow = false"
    :zIndex="1002")
    ModuleAssetPreview(:asset="previewingAsset"
      :user="user"
      :assetIdsToAdd="assetIdsToAdd"
      :selfRatings="selfRatings"
      :canNotBeAdded="canNotBeAdded"
      @closeModalWindow="showDetailModalWindow = false"
      @addSelectedAsset="addSelectedAsset"
      @onTag="onTag"
      @changePreviewingAsset="changePreviewingAsset")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-asset-card-to-add {
  width: 49.5%;
  .wrap-img {
    height: 240px;
    overflow: hidden;
    img {
      max-height: 240px;
    }
    .wrap-type {
      background: rgba(0, 0, 0, 0.3);
      span {
        color: $dark_primary_text_color;
      }
    }
    .wrap-check-icon {
      background: rgba(255, 255, 255, 0.3);
      border-radius: 50%;
    }
  }
  .wrap-tags {
    .tag {
      border: $basic_border;
    }
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import ModalWindow from '@/components/shared/ModalWindow'
import ModuleAssetPreview from '@/components/module/studio/ModuleAssetPreview'
import ItemAssetFavorite from '@/components/item/ItemAssetFavorite'

export default {
  components: {
    ModalWindow, ModuleAssetPreview, ItemAssetFavorite
  },
  props: {
    asset: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    assetIdsToAdd: {
      type: Array,
      required: true
    },
    isInPreviewWindow: {
      type: Boolean,
      default: false
    },
    selfRatings: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    comicHasViolenceRepresentation () {
      return this.selfRatings.violenceRepresentation
    },
    comicHasSexualRpresentation () {
      return this.selfRatings.sexualRpresentation
    },
    canNotBeAdded () {
      return (this.comicHasViolenceRepresentation && this.asset.termsOfUse && !this.asset.termsOfUse.violenceRepresentation)
        || (this.comicHasSexualRepresentation && this.asset.termsOfUse && !this.asset.termsOfUse.sexualRpresentation)
    }
  },
  watch: {
    user: {
      handler () {
        this.isFavoriteAsset = this.user.favoriteAssets.includes(this.asset.id)
      },
      deep: true
    }
  },
  data () {
    return {
      previewingAsset: null,
      showDetailModalWindow: false,
      isFavoriteAsset: false
    }
  },
  created () {
    this.previewingAsset = this.asset
    this.isFavoriteAsset = this.user.favoriteAssets.includes(this.asset.id)
  },
  methods: {
    addSelectedAsset (assetId) {
      if (this.comicHasViolenceRepresentation) {
        if (this.asset.termsOfUse
        && !this.asset.termsOfUse.violenceRepresentation) {
          this.$root.$emit('showNavigationMessage', {
            message: 'このアセットは暴力表現を含む漫画には利用できません',
            showOK: true
          })
          return
        }
      }
      if (this.comicHasSexualRpresentation) {
        if (this.asset.termsOfUse
        && !this.asset.termsOfUse.sexualRpresentation) {
          this.$root.$emit('showNavigationMessage', {
            message: 'このアセットは性的表現を含む漫画には利用できません',
            showOK: true
          })
          return
        }
      }
      this.$emit('addSelectedAsset', assetId)
    },
    onPreview (asset) {
      if (this.isInPreviewWindow) {
        debugger
        this.$emit('changePreviewingAsset', asset)
      } else {
        this.previewingAsset = asset
        this.showDetailModalWindow = true
      }
    },
    onTag (tag) {
      this.$emit('onTag', tag)
    },
    changePreviewingAsset (asset) {
      this.previewingAsset = asset
    },
    // async onFavorite () {
    //   if (this.isSaving) return
    //   this.isSaving = true

    //   const favoriteRef = database.userFavoriteAssetCollection(this.uid)

    //   if (this.isFavoriteAsset) {
    //     this.isFavoriteAsset = false
    //     await favoriteRef.delete(this.asset.id)
    //   } else {
    //     this.isFavoriteAsset = true
    //     const favoriteObj = {
    //       assetId: this.asset.id,
    //       createdBy: this.uid,
    //       createdAt: new Date()
    //     }
    //     await favoriteRef.set(this.asset.id, favoriteObj)
    //   }
    //   this.$root.$emit('updateFavoriteAssets', this.asset.id)

    //   await this.sleep(400)
    //   this.isSaving = false
    // }
  }
}
</script>
